export const TRADEIN_ESTIMATE_COOKIE_NAME = 'tradein_est';
